import React, { useState, useEffect, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { DialogTitle, DialogActions, Dialog, useMediaQuery, Box, CircularProgress } from '@mui/material';
import PrimaryButton from './Button/PrimaryButton';
import jsPDF from 'jspdf';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selecteFileStatus } from '../../Store/Redux/FileListSlice';
import CKTemplatePopup from '../Pages/CKEditorComponent/CKEditorpopup/CKTemplatePopup';
import { useLottie } from 'lottie-react';
import animationData from '../../Assets/Images/Loader.json';
import Permissions from '../../utils/Permissions';
// import './PDFPreview.css';
import { DownloadTemplate, deleteTemplateById } from '../../Services/APIConfig';
import ApproveRejectDialog from './Dashboard/ApproveRejectDialog';
import DownloadIcon from '../../Assets/Images/svgs/download.svg';
import { downloadBase64File } from '../../utils/util';
import CustomToast from './CustomToast';
import Loading from './LoaderComponent/Loader';

// Enable worker for PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDFPreview = ({
  thumbnailContent,
  openPDF,
  setOpenPDF,
  thumbFlag,
  setThumbFlag,
  removeMarginLeftRight,
  onFetchAPI,
  windowWidth = 682
}) => {
  const { showToast } = CustomToast();
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedFileStatus } = useSelector(state => state.fileList);
  const [pdfFile, setPdfFile] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [deleteTemplated, setDeleteTemplate] = useState(false);
  const { TemplateEngineEdit, TemplateEngineDelete } = Permissions();
  const [isLoading, setIsLoading] = useState(false);
  const [templatePdfLoading, setTemplatePdfLoading] = useState(true);
  const isMobile = useMediaQuery('(max-width: 600px)');
  const dispatch = useDispatch();
  const pdfContainerRef = useRef();
  const options = {
    animationData,
    loop: true,
    autoplay: true
  };
  const { View } = useLottie(options);

  useEffect(() => {
    if ((thumbFlag && thumbnailContent?.templateHtml) || thumbnailContent?.templateHtml === '') {
      const doc = new jsPDF();

      let marginData = { left: 5, right: 5, bottom: 5, top: 5 };

      const createTempdiv = document.createElement('div');

      //showing margin in preview
      const savedmargin = thumbnailContent?.templateConfig?.marginData;

      if (savedmargin) {
        const parseMargn = JSON.parse(thumbnailContent?.templateConfig?.marginData);

        if (parseMargn) {
          marginData.left = parseMargn.left;
          marginData.right = parseMargn.right;
          marginData.top = parseMargn.top > 5 ? parseMargn.top : 5;
          marginData.bottom = parseMargn.bottom > 5 ? parseMargn.bottom : 5;
          if (!removeMarginLeftRight) {
            createTempdiv.style.marginLeft = parseMargn.left + 'px';
            createTempdiv.style.marginRight = parseMargn.right + 'px';
          }
        }
      }

      createTempdiv.innerHTML = thumbnailContent?.templateHtml;

      const checkEditorTag = createTempdiv.querySelector('#editor');

      let modHtml = createTempdiv.innerHTML.replace(/\./g, ' .');
      createTempdiv.innerHTML = modHtml;

      // if (!checkEditorTag) {
      //   createTempdiv.id = 'editor';
      //   createTempdiv.classList.add(
      //     'ck-restricted-editing_mode_standard',
      //     'ck-blurred',
      //     'ck',
      //     'ck-content',
      //     'ck-editor__editable',
      //     'ck-editor__editable_inline'
      //   );

      //   createTempdiv.setAttribute('role', 'textbox');
      //   createTempdiv.setAttribute('dir', 'ltr');
      //   createTempdiv.setAttribute('contenteditable', 'true');
      // }

      doc.html(createTempdiv, {
        callback: function (generatedPdf) {
          const checkBorder = thumbnailContent?.templateConfig?.borderData;
          ///adding border for each page
          if (checkBorder) {
            const parseBorder = JSON.parse(checkBorder);
            if (parseBorder?.border) {
              //for adding border to each page
              for (let i = 0; i < doc.getNumberOfPages(); i++) {
                doc.setPage(i + 1);
                doc.setDrawColor(0, 0, 0);
                doc.setLineWidth(4);

                if (parseBorder.border > 4) {
                  doc.setLineWidth(2);
                } else {
                  doc.setLineWidth(parseBorder.border);
                }
                doc.rect(5, 5, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10, 'S');
              }
            }
          }

          const blob = generatedPdf.output('blob');
          const pdfBlob = new File([blob], 'thumbnail.pdf', { type: 'application/pdf' });

          setPdfFile(pdfBlob);
        },
        margin: [parseInt(marginData.top), 5, parseInt(marginData.bottom), 5],
        autoPaging: 'text',
        x: 0,
        y: 0,
        width: 190,
        windowWidth: windowWidth
      });
    }
  }, [thumbnailContent]);

  const handleClosePDF = () => {
    setOpenPDF(false);
    if (thumbFlag) {
      setThumbFlag(thumbFlag);
    }
    setTemplatePdfLoading(true);
    dispatch(selecteFileStatus(null));
    if (location.pathname === '/template') setPdfFile(null);
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const handleFileEdit = () => {
    navigate(`/edit?createmode=${true}&fileId=${thumbnailContent.templateId}`);
  };

  const handleCloseTemplate = () => {
    setPopupOpen(!isPopupOpen);
    dispatch(selecteFileStatus(null));
  };

  const handleScroll = () => {
    if (pdfContainerRef.current) {
      const scrollTop = pdfContainerRef.current.scrollTop;
      const pageHeight = pdfContainerRef.current.scrollHeight / numPages;
      const newPage = Math.floor(scrollTop / pageHeight) + 1;
      setCurrentPage(newPage);
    }
  };

  const handleDeleteAction = async () => {
    try {
      setIsLoading(true);
      const deletedTemplateById = selectedFileStatus.templateId;
      const response = await deleteTemplateById(deletedTemplateById);
      if (response?.status === 200) {
        onFetchAPI(deletedTemplateById);
        setOpenPDF(false);
        setDeleteTemplate(false);
        showToast('success', 'Template successfully deleted');
      } else {
        showToast('error', response?.error || response?.message || 'Error deleting template. Please try again later.');
      }
    } catch (error) {
      showToast('error', error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadModal = async (type, { templateId, templateName }) => {
    try {
      const response = await DownloadTemplate(templateId, type);
      if (response?.base64Data) {
        downloadBase64File(response?.base64Data || response.data, templateName + `.${type}`, type, 'application');
        showToast('success', response?.message || '');
      } else {
        showToast('error', 'No record found');
      }
    } catch (error) {
      // console.log('Download Template delete error', error);
      return error;
    }
  };

  return (
    <>
      <Dialog
        open={openPDF}
        onClose={handleClosePDF}
        maxWidth={false}
        PaperProps={{
          style: {
            maxWidth: '600px',
            borderRadius: '10px',
            margin: isMobile ? '14px' : 'intial'
          }
        }}
      >
        <Box
          sx={{
            padding: isMobile ? '16px' : '16px 25px',
            backgroundColor: '#000',
            color: '#fff'
          }}
        >
          <DialogTitle
            style={{
              fontWeight: 400,
              fontSize: '12px',
              color: '#8E8E8E',
              padding: '10px 0',
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <div style={{ alignSelf: 'flex-start' }}>
              {selectedFileStatus?.templateName || selectedFileStatus?.name}
            </div>
            {selectedFileStatus?.showDownloadOptions && (
              <div style={{ alignSelf: 'flex-end', display: 'flex', alignItems: 'center' }}>
                <span style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }}>CSV</span>
                <img
                  src={DownloadIcon}
                  alt='Download Icon'
                  style={{ cursor: 'pointer', width: '50px', height: '40px' }}
                  onClick={() => handleDownloadModal('csv', selectedFileStatus)}
                />
                <span style={{ color: 'white', fontWeight: 'bold', marginLeft: '10px', marginRight: '10px' }}>
                  XLSX
                </span>
                <img
                  src={DownloadIcon}
                  alt='Download Icon'
                  style={{ cursor: 'pointer', width: '50px', height: '40px', marginRight: '10px' }}
                  onClick={() => handleDownloadModal('xlsx', selectedFileStatus)}
                />
              </div>
            )}
          </DialogTitle>
          <div className='pdfpreview-container' style={{ display: 'flex', justifyContent: 'center' }}>
            {(thumbFlag ? pdfFile : selectedFileStatus) && ( // Use selectedFile here
              <div
                style={{
                  maxHeight: isMobile ? '73vh' : '75vh',
                  overflowX: 'hidden',
                  position: 'relative',
                  borderRadius: '8px',
                  width: '100%',
                  display: 'flex'
                }}
                ref={pdfContainerRef}
                onScroll={handleScroll}
              >
                <div className='pdf-page' style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  {selectedFileStatus?.type === 'image/png' ||
                  selectedFileStatus?.type === 'image/jpg' ||
                  selectedFileStatus?.type === 'image/jpeg' ? (
                    <img className='image-preview' src={selectedFileStatus.dataUrl} alt='error' />
                  ) : (
                    <Box width='100%'>
                      {templatePdfLoading && (
                        <Box
                          sx={{
                            minWidth: '600px',
                            minHeight: '75vh',
                            maxWidth: '600px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <div style={{ textAlign: 'center' }}>
                            <CircularProgress />
                            <p>loading document...</p>
                          </div>
                        </Box>
                      )}
                      <Box sx={{ visibility: templatePdfLoading ? 'hidden' : 'visible', overflowX: 'auto' }}>
                        <Document
                          file={thumbFlag ? pdfFile : selectedFileStatus.dataUrl}
                          onLoadSuccess={onDocumentLoadSuccess}
                          loading={View}
                        >
                          {Array.from(new Array(numPages), (el, index) => (
                            <div key={index}>
                              <Page
                                pageNumber={index + 1}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                                onRenderSuccess={() => {
                                  if (index === numPages - 1) {
                                    setTemplatePdfLoading(false);
                                  }
                                }}
                              />
                              {index < numPages - 1 && <hr style={{ borderTop: '1px solid #000', margin: '20px 0' }} />}
                            </div>
                          ))}
                        </Document>
                      </Box>
                    </Box>
                  )}
                </div>
              </div>
            )}
          </div>
          <DialogActions
            style={{
              padding: '10px 0',
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              justifyContent: isMobile ? 'intial' : 'space-between',
              alignItems: isMobile ? 'flex-start' : 'center',
              gap: isMobile ? '5px 0' : '0'
            }}
          >
            {numPages > 0 && (
              <div style={{ flex: 1 }}>
                <p>
                  {currentPage}/{numPages}
                </p>
              </div>
            )}
            <Box
              sx={{
                display: 'flex',
                gap: '0 5px',
                justifyContent: thumbFlag && location.pathname === '/template' ? 'inherit' : 'flex-end',
                marginLeft: '0px !important',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              {thumbFlag && location.pathname === '/template' ? (
                <>
                  <PrimaryButton
                    width={'116px'}
                    height={'40px'}
                    value={'Cancel'}
                    backgroundColor={'transparent'}
                    borderRadius={'8px'}
                    fontWeight={400}
                    btnClass='template-preview_btn medium5'
                    textcolor={'#B7D423'}
                    border='2px solid #B7D423'
                    onClick={handleClosePDF}
                  />
                  {TemplateEngineEdit && (
                    <PrimaryButton
                      width={'140px'}
                      height={'40px'}
                      value={'Copy Template'}
                      backgroundColor={'#B7D423'}
                      borderRadius={'8px'}
                      fontWeight={400}
                      btnClass='template-preview_btn medium5'
                      textcolor={'#21241E'}
                      onClick={() => setPopupOpen(true)}
                      customStyle={{
                        lineHeight: isMobile ? '1.2' : 'inherit'
                      }}
                    />
                  )}
                  {TemplateEngineEdit && (
                    <PrimaryButton
                      width={'116px'}
                      height={'40px'}
                      value={'Edit'}
                      backgroundColor={'#B7D423'}
                      borderRadius={'8px'}
                      fontWeight={400}
                      btnClass='template-preview_btn medium5'
                      textcolor={'#21241E'}
                      onClick={handleFileEdit}
                    />
                  )}
                  {TemplateEngineDelete && (
                    <PrimaryButton
                      value={'Delete'}
                      onClick={() => setDeleteTemplate(true)}
                      textcolor='#E96666'
                      padding='10px 16px'
                      width='97px'
                      height='40px'
                      backgroundColor='transparent'
                      borderRadius='8px'
                      border='2px solid #E96666'
                    />
                  )}
                </>
              ) : (
                <PrimaryButton
                  width={'116px'}
                  height={'40px'}
                  value={'Close'}
                  backgroundColor={'#B7D423'}
                  borderRadius={'8px'}
                  fontWeight={400}
                  textcolor={'#21241E'}
                  onClick={handleClosePDF}
                />
              )}
            </Box>
          </DialogActions>
        </Box>
      </Dialog>

      <ApproveRejectDialog
        open={deleteTemplated}
        onClose={() => setDeleteTemplate(false)}
        DialogTitles={'Delete Template'}
        DialogContents={'Are you sure you want to delete the template?'}
        handleCancelButton={'No, Cancel'}
        handleActionButton={'Yes, Delete'}
        handleActionFunction={handleDeleteAction}
        width={'100px'}
      />

      <CKTemplatePopup open={isPopupOpen} onClose={handleCloseTemplate} type='create' />
      {isLoading && <Loading open={isLoading} onClose={() => setIsLoading(false)} />}
    </>
  );
};

export default PDFPreview;
